import {
  Alert,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  Select,
  Stack,
  Heading,
  Textarea,
} from "@chakra-ui/react";
import React, { useState } from "react";
import MainHeader from "./MainHeader";
import Footer from "./Footer";
import { Field, Form, Formik } from "formik";
import { validateForm } from "../functions/validations";
import { contact } from "../functions/api";
import { trackFormSubmission } from "../functions/analytics";

const Contact = () => {
  const [codeError, setCodeError] = useState();
  const [submitted, setSubmitted] = useState(false);

  return (
    <Flex direction="column" minH="100vh" width="100%">
      <MainHeader variant="info" />
      <Flex as="main" role="main" direction="column" flex="1" bg="#ebe8f1">
        <Stack
          bg="#ebe8f1"
          padding="32px"
          fontFamily="Garamond"
          fontSize="xl"
          marginTop="8px"
          alignItems="flex-start"
          spacing={3}
        >
          <Stack
            direction={{ base: "column", lg: "row" }}
            alignItems="center"
            justifyContent="space-around"
          >
            <Image src="/together.jpg" alt="Raven Support Network team working together with newcomers" h="100%" w="50%" />
            <Stack>
              <Heading as="h1" size="xl">
                We want to hear from you
              </Heading>

              {codeError ? (
                <Alert status="error" fontSize="lg">
                  {codeError}
                </Alert>
              ) : null}
              {submitted ? (
                <Alert status="success" fontSize="lg">
                  Thank you! Your message has been sent. We'll get back to you soon.
                </Alert>
              ) : null}

              <Formik
                initialValues={{
                  email: "",
                  firstName: "",
                  lastName: "",
                }}
                validate={(values) => validateForm(values)}
                onSubmit={async (values, actions) => {
                  try {
                    setCodeError();
                    const { email, firstName, lastName, heard, status, more } =
                      values;
                    await contact(
                      email,
                      firstName,
                      lastName,
                      heard,
                      status,
                      more
                    );
                    trackFormSubmission("contact");
                    actions.setSubmitting(false);
                    actions.resetForm();
                    setSubmitted(true);
                  } catch (err) {
                    actions.setSubmitting(false);
                    setSubmitted(false);
                    setCodeError(
                      err.response?.data?.message || "Something went wrong. Please try again."
                    );
                  }
                }}
              >
                {(props) => (
                  <Form>
                    <Stack spacing="5">
                      <HStack>
                        <Field name="firstName">
                          {({ field, form }) => (
                            <FormControl
                              isRequired
                              isInvalid={
                                form.errors.firstName && form.touched.firstName
                              }
                            >
                              <FormLabel>First Name</FormLabel>
                              <Input
                                {...field}
                                bg="white"
                                placeholder="First name"
                              />
                              <FormErrorMessage>
                                {form.errors.firstName}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                        <Field name="lastName">
                          {({ field, form }) => (
                            <FormControl
                              isRequired
                              isInvalid={
                                form.errors.lastName && form.touched.lastName
                              }
                            >
                              <FormLabel>Last Name</FormLabel>
                              <Input
                                {...field}
                                bg="white"
                                placeholder="Last name"
                              />
                              <FormErrorMessage>
                                {form.errors.lastName}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>
                      </HStack>
                      <Field name="email" type="email">
                        {({ field, form }) => (
                          <FormControl
                            isRequired
                            isInvalid={form.errors.email && form.touched.email}
                          >
                            <FormLabel htmlFor="email">Email</FormLabel>
                            <Input {...field} bg="white" placeholder="Email" />
                            <FormErrorMessage>
                              {form.errors.email}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="heard">
                        {({ field, form }) => (
                          <FormControl isRequired>
                            <FormLabel>How did you hear about us?</FormLabel>
                            <Select {...field} bg="white" placeholder="Select">
                              <option>Friend</option>
                              <option>Google</option>
                              <option>Social Media</option>
                              <option>Other</option>
                            </Select>
                          </FormControl>
                        )}
                      </Field>
                      <Field name="status">
                        {({ field, form }) => (
                          <FormControl isRequired>
                            <FormLabel>Status in Canada</FormLabel>
                            <Select
                              {...field}
                              bg="white"
                              placeholder="Select status"
                            >
                              <option>Visitor</option>
                              <option>Student</option>
                              <option>Worker</option>
                              <option>Permanent Resident</option>
                              <option>None</option>
                            </Select>
                          </FormControl>
                        )}
                      </Field>
                      <Field name="more">
                        {({ field, form }) => (
                          <FormControl isRequired>
                            <FormLabel>
                              Tell us more on how we can aid your settlement
                              experience
                            </FormLabel>
                            <Textarea {...field} bg="white" placeholder="..." />
                          </FormControl>
                        )}
                      </Field>
                      <Button
                        type="submit"
                        colorScheme="yellow"
                        isLoading={props.isSubmitting}
                      >
                        Submit
                      </Button>
                    </Stack>
                  </Form>
                )}
              </Formik>
            </Stack>
          </Stack>
        </Stack>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default Contact;
